import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { MatDialog } from '@angular/material';

import { Template } from '../../../../_models/template';
import { Size } from '../../../../_models/size';
import { Update } from '../../../../_models/update';
import { CardService } from '../../card.service';
import { EditCardComponent } from '../../modify-card/edit-card/edit-card.component';
import { ApplicationNotificationService } from '../../../../shared/application-notification.service';


@Component({
  moduleId: module.id,
  selector: 'template-component',
  templateUrl: 'template.component.html',
  styleUrls: ['./template.component.css']
})
export class TemplateComponent implements OnChanges {
  @Input() template:Template;
  @Input() size:Size;
  @Input() updateInput:{update:Update, copyToID:string};
  @Output() updateOutput = new EventEmitter<{update:Update, copyToID:string}>();
  @Output() reloadSize = new EventEmitter<{ update: Update, newCard: boolean}>();

  constructor(private cardService: CardService, public dialog: MatDialog,
              public notificationService: ApplicationNotificationService) {}

  ngOnChanges():void {
    if (this.updateInput) {
      if (this.updateInput['copyToID'] == this.template.template_id) {
        this.triggerUpdate(this.updateInput.update);
        setTimeout(() => {
          this.notificationService.addGrowl('Automatically copied settings to ' + this.template.name);
        });
      }
    }
  }

  toggleEnabled(): void {
    this.template.enabled = !this.template.enabled;
  }

  triggerUpdate(newUpdate:Update):void {
    this.updateTemplateSVG(newUpdate);
  }

  updateTemplateSVG(newUpdate:Update):void {
    this.cardService.updateTemplate(this.template, newUpdate);
  }

  sendUpdates(newUpdate:Update):void {
    // Look if we have contents_equal_to_template variables, these are templates that also need to be updated.
    if (this.template.contents_equal_to_template !== null) {
      const output:{update:Update, copyToID:string} = {'update': newUpdate, 'copyToID': this.template.contents_equal_to_template};
      this.updateOutput.emit(output);
    }
    // Also trigger the update to the editted card
    this.triggerUpdate(newUpdate);
  }

  openEditComponent(newCard = false) {
    let templateThatWillBeModified = { ...this.template};
    let dialogRef = this.dialog.open(EditCardComponent, {
      width: '1000px',
      data: {
        template: templateThatWillBeModified,
        newCard: newCard,
        size: this.size
      },
    });
    dialogRef.afterClosed().subscribe((result:Template) => {
      if (result) {
        let receivedUpdate = new Update(result, this.template.name);
        if (!newCard) {
          this.sendUpdates(receivedUpdate);
        } else {
          // Add our new card to the list
          this.cardService.createNewTemplate(this.size, result);
          this.notificationService.addGrowl('Added a new template called ' + result.name);
        }
        // If we have updated our name, reload the sizes component
        if (receivedUpdate.old_name !== receivedUpdate.name) {
            let output = {'update': receivedUpdate, 'newCard': newCard};
            this.reloadSize.emit(output);
          }
      } else {
        this.cardService.closeUploading();
      }
    });
  }

}





// WEBPACK FOOTER //
// /app/src/app/hq/cards/view-cards/grouped-by-template/template.component.ts